import { render, staticRenderFns } from "./Evacuator.vue?vue&type=template&id=72388266"
import script from "./Evacuator.vue?vue&type=script&lang=js"
export * from "./Evacuator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports